import { Box, Typography, Modal, Button } from "@mui/material";

import { AlertBar } from "../../../../components";
import { useState } from "react";
import { useSelector } from "react-redux";
import LoadingButton from "@mui/lab/LoadingButton";
import { selectUserEmail } from "../../../../redux/Slice/Authentication/AuthenticationSlice";
import { sendCommandControl } from "../../../../services/apis";
import { useMutation } from "@tanstack/react-query";

const getModalStyle = () => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 404,
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
  maxHeight: "95vh",
  overflowY: "auto",
});

export default function RebootSelectedUnit({ openRebootUnitModel, setOpenRebootUnitModel, setValue, unit, setAlertState }: any) {
  const userEmail = useSelector(selectUserEmail);
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setValue('offline')
    setIsLoading(false);
    setOpenRebootUnitModel(false)
  };

  const bypassMutation = useMutation<number, Error, { control: string; units: string[] }>({
    mutationFn: ({ control, units }) => sendCommandControl(control, units),
    onSuccess: () => {
      setIsLoading(false);
      handleClose();
      setAlertState({
        isAlert: true,
        severity: "info",
        title: "",
        description: "PACE AI device on selected unit is waiting to be rebooted.",
        resetOpen: true,
      });
    },
    onError: (error) => {
      setIsLoading(false);
      handleClose();
      setAlertState({
        isAlert: true,
        severity: "error",
        title: "",
        description: "Failed to reboot PACE AI device on selected unit. Please try again later.",
        resetOpen: true,
      });
    },
  });


  const handleSendCommand = () => {
    const serialNums: string[] = [unit?.pace_device_serial_number];
    setIsLoading(true);
    bypassMutation.mutate({ control: "reboot", units: serialNums });
  };
  const [showAlert, setShowAlert] = useState(true);

  return (
    <Modal open={openRebootUnitModel} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={getModalStyle}>
        <Typography id="modal-modal-title" variant="h6">
          reboot selected unit
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <AlertBar
          severity={"warning"}
          title={"Warning:"}
          description={"This action will restart the PACE AI device for the selected units."}
          variant={"standard"}
          show={showAlert}
          setShow={setShowAlert}
        />
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          Please review your selection carefully before proceeding:
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Typography id="modal-modal-title" variant="body1">
          {`1. ${unit?.unit_name || ""}`}
        </Typography>
        <Box sx={{ marginTop: "20px" }} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button variant="text" color="primary" size="medium" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="contained"
            onClick={handleSendCommand}
            size="medium"
          >
            Reboot
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
}
